module.exports = __webpack_public_path__ + "img/初予婚纱.f251f558.jpg";